<template>
  <div>
    <landing :shows-logout="true">
      <b-container fluid>
        <b-row v-if="isProcessMessaging" style="margin: 0 0 1rem 0">
          <b-col style="padding: 0">
            <b-card>
              <b-card-text v-if="interview.isFailed || training.isFailed">
                {{ $t('interviewPage.recruitment.failed') }}
              </b-card-text>
              <b-card-text
                v-else-if="
                  interview.isPassed && (training.isQuizDone || isWarehouse)
                "
              >
                {{ $t('interviewPage.recruitment.processDone') }}
              </b-card-text>
              <b-card-text v-else-if="isExtraUserPassedInterview">
                {{ $t('interviewPage.recruitment.processExtraDone') }}
              </b-card-text>
              <b-card-text v-else-if="isBookedEventDisplayed">
                {{ $t('interviewPage.recruitment.rescheduleInterview') }}
              </b-card-text>
              <b-card-text v-else>
                {{ $t('interviewPage.recruitment.trainingNotBooked') }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row
          v-show="!isCalendlyHidden && !isExtraUserPassedInterview"
          style="margin: 0"
        >
          <div
            id="calendly-inline-widget"
            ref="calendly-inline-widget"
            style="width:100%;height:650px;z-index: 10;"
            data-auto-load="false"
          ></div>
        </b-row>
      </b-container>

      <div v-if="isExtraUserPassedInterview">
        <download-mobile-app />
      </div>

      <start-quiz
        v-else-if="training.isQuizPending && !training.isQuizDone"
        @quizFinished="setQuizDone"
      ></start-quiz>

      <b-container
        v-if="isCoreUserInterviewPassed"
        fluid
        class="mt-3 d-flex justify-content-center"
      >
        <b-card class="w-100">
          <p class="p-2">
            Κατέβασε το SLM Crew για να συμπληρώσεις τα στοιχεία σου
          </p>
          <download-mobile-app />
        </b-card>
      </b-container>
    </landing>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import firebase from 'firebase/app';
import 'firebase/analytics';

import Landing from '../components/Landing.vue';
import StartQuiz from './quiz/StartQuiz.vue';
import DownloadMobileApp from '../components/DownloadMobileApp.vue';
import { assignRandomUrlInterviewHost } from '../helpers/randomInterviewHost.js';

export default {
  name: 'Interview',
  components: {
    Landing,
    StartQuiz,
    DownloadMobileApp
  },
  data() {
    return {
      isProcessMessaging: false,
      isCalendlyHidden: true,
      isRescheduledMessageDisplayed: false,

      interview: {
        isBooked: false,
        isFailed: false,
        isPassed: false
      },
      training: {
        isBooked: false,
        isFailed: false,
        isPassed: false,
        isQuizPending: false,
        isQuizDone: false
      }
    };
  },
  computed: {
    ...mapGetters(['recruitmentInfo', 'userInfo', 'isWarehouse']),
    isExtraUserPassedInterview() {
      return (
        this.interview.isPassed &&
        this.training.isPassed &&
        this.$store.getters.slmType === 'extra'
      );
    },
    isCoreUserInterviewPassed() {
      return (
        this.interview.isPassed &&
        this.$store.getters.slmType === 'core' &&
        !(this.training.isFailed || this.training.isQuizPending)
      );
    },
    isBookedEventDisplayed() {
      const isInterviewSlotDisplaying =
        this.interview.isBooked &&
        !(this.interview.isFailed || this.interview.isPassed);

      const isTrainingSlotDisplaying =
        this.training.isBooked &&
        !(this.training.isFailed || this.training.isPassed);

      return (
        isInterviewSlotDisplaying ||
        isTrainingSlotDisplaying ||
        this.isRescheduledMessageDisplayed
      );
    }
  },
  async mounted() {
    await this.$loadScript(
      'https://assets.calendly.com/assets/external/widget.js'
    ).catch(console.log);

    this.setRecruitmentDetails();
    window.addEventListener('message', this.listenToCalendlyMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.listenToCalendlyMessage);
  },
  methods: {
    async setRecruitmentDetails() {
      const { interview, training } = this.recruitmentInfo;

      this.interview.isBooked = !!interview.date;
      this.interview.isFailed = interview.passed === false;
      this.interview.isPassed = interview.passed === true;

      if (this.interview.isPassed) {
        this.training.isBooked = !!training.date;
        this.training.isFailed = training.passed === false;
        this.training.isPassed = training.passed === true;
        this.training.isQuizPending =
          this.training.isPassed && !training.quized;
        this.training.isQuizDone = !!training.quized;
      }

      this.adjustScreenComponents();
    },
    async adjustScreenComponents() {
      this.isProcessMessaging =
        this.interview.isFailed ||
        this.training.isFailed ||
        (this.interview.isPassed && !this.training.isBooked) ||
        this.training.isQuizDone ||
        this.isBookedEventDisplayed;

      if (
        this.interview.isFailed ||
        this.training.isFailed ||
        this.training.isPassed ||
        (this.interview.isPassed && this.isWarehouse)
      )
        return;

      this.isCalendlyHidden = false;
      this.initializeCalendly();
    },
    setQuizDone() {
      this.training.isQuizPending = false;
      this.training.isQuizDone = true;
      this.adjustScreenComponents();
    },
    calendlyBaseUrl() {
      const cityId = parseInt(this.$store.getters.workingCity?.id, 10);

      // interview
      if (!this.interview.isPassed) {
        const isExtra = this.$store.getters.slmType === 'extra';
        const isWarehouse = this.$store.getters.department === 'warehouse';

        return assignRandomUrlInterviewHost(isExtra, isWarehouse, cityId);
      }
      // training
      if (cityId === 2) {
        return process.env.VUE_APP_CALENDLY_TRAINING_EVENT_PATH_THESSALONIKI;
      }
      if (cityId === 5) {
        return process.env.VUE_APP_CALENDLY_TRAINING_EVENT_PATH_PAIANIA;
      }
      return process.env.VUE_APP_CALENDLY_TRAINING_EVENT_PATH_ATHENS;
    },
    initializeCalendly() {
      this.$refs['calendly-inline-widget'].innerHTML = '';

      const eventPath = this.calendlyBaseUrl();
      let url = '';
      let prefill = {};

      const hasAlreadyBookedEvent =
        !this.interview.isBooked ||
        (this.interview.isPassed && !this.training.isBooked);

      if (hasAlreadyBookedEvent) {
        url = `${eventPath}/`;
        prefill = {
          name: `${this.userInfo.first_name} ${this.userInfo.last_name}`,
          email: this.userInfo.email,
          phone_number: this.userInfo.phone,
          customAnswers: {
            a1: this.userInfo.id
          }
        };
      } else {
        const inviteeUUID = this.interview.isPassed
          ? this.recruitmentInfo.training.calendly_invitee_uuid
          : this.recruitmentInfo.interview.calendly_invitee_uuid;
        url = `${eventPath}/invitees/${inviteeUUID}`;
      }

      // eslint-disable-next-line no-undef
      Calendly.initInlineWidget({
        url,
        parentElement: document.getElementById('calendly-inline-widget'),
        prefill,
        utm: {}
      });
    },
    listenToCalendlyMessage(e) {
      const isCalendlyEvent = event => {
        return event.data.event && event.data.event.indexOf('calendly') === 0;
      };
      const isSheduledEvent = event => {
        return event.data.event === 'calendly.event_scheduled';
      };

      if (isCalendlyEvent(e) && isSheduledEvent(e)) {
        if (this.interview.isPassed) {
          this.training.isBooked = true;
        } else {
          this.interview.isBooked = true;
        }
        this.isRescheduledMessageDisplayed = true;
        this.isProcessMessaging = true;

        window.fbq('track', 'Schedule');
        firebase.analytics().logEvent('shedule');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$white: #fff;
$orange: #f68b24;
$orange8: rgba(246, 139, 36, 0.8);

.btn-primary {
  border-color: $orange8;
  background: $orange8;
  color: $white;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  border-color: $orange;
  background: $orange;
  color: $white;
}
</style>
